// Section 2 budget (M6, ADR-0017): a newly built object that goes into the draft whole (a
// report map of every person, a person's new streaks) is frozen first, so Immer's finish does
// not walk it looking for drafts: the object is plain data built in this phase from committed
// values. When the run auto-freezes (dev and tests: the committed state is frozen) it is frozen
// deeply, as Immer would; otherwise only its root, which is all the finish needs to skip it.
import { freeze } from 'immer';
import type { GameState } from '../../core/types';

export function seal<T extends object>(ctx: { state: GameState }, value: T): T {
  return Object.isFrozen(ctx.state) ? freeze(value, true) : Object.freeze(value);
}
